import React from 'react'
import {Card, Container, Row, Col} from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

const CGU = () => {
    const { t } = useTranslation();
    
    return (
        <>
            <Container>
                <Container fluid>
                    <Row>
                        <Col lg="12">
                            <br/>
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">{t("CGU")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("Date de mise à jour : Février 2025")}</p>
                                    <p>{t("Les présentes Conditions Générales d'Utilisation (CGU) ont pour objet de définir les modalités d'accès et d'utilisation du site www.seeks.biz (ci-après le « Site »), édité par ONYRIX SOFTWARE, SAS au capital de 1 000 €, immatriculée au RCS de Béziers sous le numéro 935 385 559, dont le siège social est situé au 49 Boulevard de l'Europe, 34500 Béziers.")}</p>
                                </Card.Body>
                            </Card>
                            
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">1. {t("Objet de la plateforme")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("SEEKS.BIZ est une plateforme de mise en relation BtoB entre professionnels. Elle permet :")}</p>
                                    <ul>
                                        <li>{t("la publication d'offres de services ou de besoins professionnels,")}</li>
                                        <li>{t("l'utilisation d'un système de \"mots-hameçons\" pour capter des opportunités,")}</li>
                                        <li>{t("le partage de documents et d'informations,")}</li>
                                        <li>{t("l'accès à des services publicitaires ou analytiques.")}</li>
                                    </ul>
                                    <p>{t("La plateforme agit uniquement en tant qu'intermédiaire technique.")}</p>
                                </Card.Body>
                            </Card>
                            
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">2. {t("Acceptation des CGU")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("L'accès et l'utilisation de SEEKS.BIZ impliquent l'acceptation pleine et entière des présentes CGU. Si vous n'acceptez pas ces conditions, vous devez cesser toute utilisation du site.")}</p>
                                </Card.Body>
                            </Card>
                            
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">3. {t("Accès au service")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <ul>
                                        <li>{t("L'accès est réservé aux professionnels disposant d'un numéro SIRET ou KBIS valide.")}</li>
                                        <li>{t("L'inscription requiert une validation manuelle par l'équipe de SEEKS.")}</li>
                                        <li>{t("L'utilisateur est responsable de la véracité des informations fournies.")}</li>
                                    </ul>
                                </Card.Body>
                            </Card>
                            
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">4. {t("Compte utilisateur")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("Chaque utilisateur dispose d'un compte personnel sécurisé. Il s'engage à :")}</p>
                                    <ul>
                                        <li>{t("préserver la confidentialité de ses identifiants,")}</li>
                                        <li>{t("ne pas usurper l'identité d'un tiers,")}</li>
                                        <li>{t("ne pas créer plusieurs comptes pour contourner les limites d'usage.")}</li>
                                    </ul>
                                </Card.Body>
                            </Card>
                            
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">5. {t("Services gratuits et payants")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("Certains services sont gratuits, d'autres accessibles par abonnement. Les modalités et prix sont décrits dans les CGV.")}</p>
                                </Card.Body>
                            </Card>
                            
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">6. {t("Propriété intellectuelle")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("Tous les contenus de SEEKS (texte, logo, marque, interface) sont protégés. Toute reproduction ou exploitation sans autorisation est strictement interdite.")}</p>
                                </Card.Body>
                            </Card>
                            
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">7. {t("Comportements interdits")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("Il est strictement interdit de :")}</p>
                                    <ul>
                                        <li>{t("publier des contenus illégaux, diffamatoires ou trompeurs,")}</li>
                                        <li>{t("utiliser SEEKS à des fins commerciales non autorisées (spam, publicité sauvage, etc.),")}</li>
                                        <li>{t("détourner la plateforme de son usage initial.")}</li>
                                    </ul>
                                </Card.Body>
                            </Card>
                            
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">8. {t("Modération")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("SEEKS se réserve le droit de suspendre ou supprimer tout compte ne respectant pas les présentes CGU, sans préavis, notamment en cas de comportement abusif ou frauduleux.")}</p>
                                </Card.Body>
                            </Card>
                            
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">9. {t("Responsabilités")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("SEEKS n'est pas partie aux échanges ou transactions entre utilisateurs. Chaque professionnel reste responsable de ses engagements. La plateforme ne garantit ni les résultats, ni la solvabilité des utilisateurs.")}</p>
                                </Card.Body>
                            </Card>
                            
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">10. {t("Données personnelles")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("Les données collectées sont traitées selon le RGPD. Voir notre Politique de confidentialité pour plus d'informations.")}</p>
                                </Card.Body>
                            </Card>
                            
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">11. {t("Durée et résiliation")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("L'inscription est valable jusqu'à résiliation par l'utilisateur ou par SEEKS, dans le respect des présentes CGU.")}</p>
                                </Card.Body>
                            </Card>
                            
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">12. {t("Modification des CGU")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("SEEKS se réserve le droit de modifier les CGU à tout moment. Les utilisateurs seront notifiés des mises à jour. L'usage continu du site vaut acceptation des nouvelles conditions.")}</p>
                                </Card.Body>
                            </Card>
                            
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">13. {t("Loi applicable et juridiction compétente")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("Les présentes CGU sont soumises au droit français. Tout litige relatif à leur interprétation ou exécution sera de la compétence exclusive des tribunaux du ressort de la Cour d'appel de Paris.")}</p>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </>
    )
}

export default CGU
